module.exports = __webpack_public_path__ + "static/media/electrician-3087536.63fcf112.jpg";